import React from 'react';
import { useAtomValue } from 'jotai';
import { Services } from '@src/types/Services';
import { EPopup } from '@src/types/common';
import { Modal } from '@src/components/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import { DownloadCollection } from './components/DownloadCollection';
import { NotFound } from './components/NotFound';
import Settings from './components/Settings/index';
import UserSettings from './components/UserSettings/index';
import AddInfluencer from './components/Settings/AddInfluencer/index';
import Blacklist from './components/Settings/Blacklist';
import EditInfluencer from './components/Settings/EditInfluencer/index';
import PromptConfirm from './components/PromptConfirm/index';
import CollectOverlay from './components/CollectOverlay';
import SetCreatorCountriesPopup from './components/SetCreatorCountriesOverlay';
import CRMSettings from './components/CRMSettings';
import { TemplateSelector } from '@src/components/TemplateSelector';
import GetRightsController from '@src/pages/Media/GetRights/GetRightsController';
import { popupsAtom, popupLoadingAtom, setPopup, setCrmSelectedTemplate, rightsSelectedTemplateAtom, setRightsSelectedTemplate } from '@src/state/popupAtoms';

interface OwnProps {
  services: Services;
}

export default function Popups({ services }: OwnProps) {
  const popups = useAtomValue(popupsAtom);
  const popupLoading = useAtomValue(popupLoadingAtom);
  const rightsSelectedTemplate = useAtomValue(rightsSelectedTemplateAtom);

  const templateSelector = popups[EPopup.templateSelector];

  return (
    <div>
      <CollectOverlay />
      {popups.settings ? <Settings services={services} /> : null}
      {popups.userSettings ? <UserSettings services={services} /> : null}
      {popups.addInfluencer ? <AddInfluencer services={services} /> : null}
      {popups.addBlacklist ? <Blacklist services={services} /> : null}
      {popups.editInfluencer ? (
        <EditInfluencer influencer={popups.editInfluencer} />
      ) : null}
      {popups.notfound ? <NotFound /> : null}
      {popups.downloadCollection ? (
        <DownloadCollection collectionId={popups.downloadCollection} />
      ) : null}
      {popups.setCreatorCountriesOverlay ? <SetCreatorCountriesPopup /> : null}
      {popupLoading ? (
        <Modal style={{ zIndex: 10 }}>
          <CircularProgress style={{ margin: 'auto' }} />
        </Modal>
      ) : null}

      {/* Popup layering order: GetRights/DMModal (bottom) -> TemplateSelector (middle) -> CRM Settings (top) */}
      {popups.getRights ? <GetRightsController services={services} /> : null}

      {templateSelector ? (
        <TemplateSelector
          isOpen={true}
          onClose={() => setPopup(EPopup.templateSelector, null)}
          onSelectTemplate={(template) => {
            const filterType = typeof templateSelector === 'object'
              ? templateSelector?.filterType
              : null;

            if (filterType === 'DM') {
              setCrmSelectedTemplate(template);
            } else {
            setRightsSelectedTemplate(template);
            }

            setPopup(EPopup.templateSelector, null);
          }}
          selectedTemplateId={
            typeof templateSelector === 'object' && templateSelector?.filterType === 'DM'
              ? templateSelector?.selectedTemplateId || null
              : rightsSelectedTemplate?._id || null
          }
          filterType={
            typeof templateSelector === 'object'
              ? templateSelector?.filterType || null
              : null
          }
        />
      ) : null}

      {popups.crmSettings ? <CRMSettings services={services} /> : null}

      {/* PromptConfirm on top of every other popup */}
      {popups.promptconfirm ? <PromptConfirm /> : null}
    </div>
  );
}
